import { Select, Tabs, TabsProps } from 'antd'
import React, { memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import FlowStatQuery from './pannels/FlowStatQuery'
import styles from './index.module.scss'
import { useSelector } from 'react-redux'
import { AppState } from '@/store/types'
import { WorkspaceMemberModel } from '@/services/apis/user/model'
import cacheUtil, { TIME_ZONE } from '@/utils/cache'

const Analyze = memo(() => {
  const { t } = useTranslation()
  const userInfo = useSelector<AppState, WorkspaceMemberModel>(state => {
    return state.user.userInfo as any
  })
  const [UTC, setUTC] = useState(cacheUtil.get(`${TIME_ZONE}${userInfo?.userKey}`) !== '8' ? 0 : 8)

  const handleChange = (value: number) => {
    setUTC(value)
    cacheUtil.set(`${TIME_ZONE}${userInfo?.userKey}`, value)
  }
  const items: TabsProps['items'] = [
    {
      key: 'flow',
      label: t('analyze.flow'),
      children: <FlowStatQuery UTC={UTC} />,
    },
  ]

  useEffect(() => {
    setUTC(cacheUtil.get(`${TIME_ZONE}${userInfo?.userKey}`) !== '8' ? 0 : 8)
  }, [userInfo])

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.left}> {t('analyze.title')}</div>
        <div className={styles.right}>
          {t('analyze.timeZone')}
          <Select
            value={UTC}
            options={[
              { value: 0, label: 'UTC' },
              { value: 8, label: 'UTC+8 ' },
            ]}
            style={{ width: '130px', marginLeft: '10px' }}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className={styles.content}>
        <Tabs
          items={items}
          size="large"
          className={styles.tabs}
          animated={true}
          destroyInactiveTabPane={true}
        />
      </div>
    </div>
  )
})

export default Analyze
